import { Autocomplete, AutocompleteProps } from '@/ui/components/controls/Autocomplete';
import { Field, FieldProps } from '@/ui/components/form/Field';
import { defineComponent, h } from 'vue';
import { SetterCallback } from '@/ui/types';

type AutocompleteFieldProps<T = number> = AutocompleteProps<T> & FieldProps;

export const AutocompleteField = defineComponent<AutocompleteFieldProps>({
  props: [
    'name', 'label', 'required', 'errors', 'hideLabel', 'horizontal',
    'starred', 'classes', 'disabled', 'readonly', 'tooltipText', 'overrideErrorMessage',
    'value', 'placeholder', 'data', 'maxHeight', 'limit',
  ],
  setup(props, context) {
    type T = typeof props.value;

    return function render() {
      const fieldProps: FieldProps = {
        label: props.label,
        name: props.name,
        required: props.required,
        errors: props.errors,
        hideLabel: props.hideLabel,
        horizontal: props.horizontal,
        disabled: props.disabled,
        tooltipText: props.tooltipText,
      };

      const autocompleteProps = {
        value: props.value,
        data: props.data,
        disabled: props.disabled,
        placeholder: props.placeholder,
        maxHeight: props.maxHeight,
        limit: props.limit,
      };

      return h(Field, { props: fieldProps }, [
        h(Autocomplete, {
          props: autocompleteProps,
          on: {
            input: (value: T) => {
              context.emit('input', value);
            },
          },
        }),
      ]);
    };
  },
});

export function autocompleteField<T = number>(props: AutocompleteFieldProps<T>, input: SetterCallback<T>) {
  return h(AutocompleteField, {
    props,
    on: { input },
  });
}
